import { useConnection } from "context/Connections";

export default useConnection